import { OrderWizardSteps } from './OrderWizardSteps'
import AppConfigService from '../../shared/services/AppConfigService'
import { ProductGroupCode } from '../../shared/utils/ProductEnums'

export const Routes = {
  PACKAGE_SELECTOR: {
    path: '/dijcsomagok/:groupCode',
    name: 'PACKAGE_SELECTOR',
    activeStep: OrderWizardSteps.PACKAGE_SELECTOR
  },
  VEHICLE_REGISTRATION: {
    path: '/jarmuregisztracio',
    name: 'VEHICLE_REGISTRATION',
    activeStep: OrderWizardSteps.VEHICLE_REGISTRATION
  },
  CONTRACT_INPUT: {
    path: '/szerzodeses_adatok',
    name: 'CONTRACT_INPUT',
    activeStep: OrderWizardSteps.CONTRACT_INPUT
  },
  PAYMENT: {
    path: '/fizetesi_beallitasok',
    name: 'PAYMENT',
    activeStep: OrderWizardSteps.PAYMENT
  },
  THANK_YOU_BANKCARD: {
    path: '/sikeres_kartyasfizetes',
    name: 'THANK_YOU_BANKCARD',
    activeStep: OrderWizardSteps.THANKS
  },
  THANK_YOU_WIRE: {
    path: '/sikeres_utalas',
    name: 'THANK_YOU_WIRE',
    activeStep: OrderWizardSteps.THANKS
  },
  PAYMENT_FAILED: {
    path: '/sikertelen_fizetes',
    name: 'PAYMENT_FAILED',
    activeStep: OrderWizardSteps.PAYMENT
  },
  SIMPLE_PAY_PAYMENT_RESULT: {
    path: '/paymentresult',
    name: 'SIMPLE_PAY_PAYMENT_RESULT'
  },
  LOGIN: {
    path: '/login',
    name: 'LOGIN'
  },
  INVOICE: {
    path: '/dijbekero/:invoiceId/:key',
    name: 'INVOICE'
  },

  getPackageSelectorUrlForGroupCode (groupCode) {
    return this.PACKAGE_SELECTOR.path.replace(':groupCode', groupCode)
  },

  defaultPackageSelector () {
    const defaults = AppConfigService.getConfigValueSync('defaults')
    return this.PACKAGE_SELECTOR.path.replace(':groupCode', defaults && defaults.groupCode ? defaults.groupCode : ProductGroupCode.TRUCK)
  },

  home () {
    return this.defaultPackageSelector()
  }
}
